import normalize from "app/utils/normalize";
import React from "react";
import { Box } from "../Box";
import { MainText } from "../MainText";
import { MainTitle } from "../MainTitle";

interface IProps {
  title: string;
  text: string;
}

const OnboardingWebTitle = ({ title, text }: IProps) => {
  return (
    <Box marginBottom="l" width={normalize(344)}>
      <MainTitle variant="l8-bold" marginBottom="xs">
        {title}
      </MainTitle>
      <MainText variant="l5-medium" color="neutral.500">
        {text}
      </MainText>
    </Box>
  );
};

export default OnboardingWebTitle;
